import { CARD_NUMBER_MODAL_TITLE_LOADING } from '../constants';
import { getMessages } from '../../../../../../../../../store/constants';

export const getBoardCardNumberModalTitle = (
    isLoading: boolean,
    prefix: string
) => {
    return isLoading ? CARD_NUMBER_MODAL_TITLE_LOADING : getMessages().getText('cardNumber.modal.title', null, prefix);
}
